import { createAction, props } from '@ngrx/store';

export const saveCutOffDaysForChange = createAction(
  '[CutOffDay] Load SaveCutOffDaysForChange',
  props<{ request: { businessId: string; cutOffDays: number } }>()
);

export const saveCutOffDaysForChangeSuccess = createAction(
  '[CutOffDay] Load SaveCutOffDaysForChange Success',
  props<{ response: string }>()
);

export const saveCutOffDaysForChangeFailure = createAction(
  '[CutOffDay] Load SaveCutOffDaysForChange Failure',
  props<{ error: Error | any }>()
);
